import { Link } from "react-router-dom";
import { ArrowLeft, Mail, Phone, Globe } from "lucide-react";
import { Brand } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { Nice } from "@/components/Nice";
import { WhyNice } from "@/components/WhyNice";
import { Testimonials } from "@/components/Testimonials";

const CONTACT = [
  { key: "website", icon: Globe, value: "www.BurrhausCounseling.com", href: (v) => `https://${v}` },
  { key: "email", icon: Mail, value: "", href: (v) => `mailto:${v}` },
  { key: "phone", icon: Phone, value: "", href: (v) => `tel:${v.replace(/[^\d+]/g, "")}` },
];

const SERVICES = [
  "Life Cycle Work", "Child & Teen Counseling", "Family Transitions",
  "Retreats & Workshops", "Author & Speaker", "Podcast Host",
];

const Contact = () => {
  const items = CONTACT.filter((c) => c.value);
  if (!items.length) return <p className="pp-sub" data-testid="contact-coming-soon">Contact details coming soon.</p>;
  return (
    <ul className="space-y-3">
      {items.map(({ key, icon: Icon, value, href }) => (
        <li key={key}>
          <a href={href(value)} className="pp-contact" data-testid={`contact-${key}`} target={key === "website" ? "_blank" : undefined} rel="noreferrer">
            <Icon className="h-4 w-4" /> {value}
          </a>
        </li>
      ))}
    </ul>
  );
};

export default function About() {
  return (
    <div className="pp-app mode-kid" data-testid="about-page">
      <header className="pp-header">
        <Brand />
        <Link to="/" className="pp-ghost" data-testid="about-back-link"><ArrowLeft className="h-4 w-4" /> Back to <Nice /></Link>
      </header>
      <main className="pp-main pp-wide">
        <WhyNice className="max-w-3xl" />
        <Testimonials className="mt-6 mb-12 max-w-3xl" />
        <div className="mb-12" />
        <p className="pp-label">About BurrHaus Counseling, LLC.</p>
        <div className="pp-about">
          <div className="pp-about-photo" data-testid="about-photo">
            <img src="/stephanie.jpg" alt="Stephanie Lowe Burry, LCSW" onError={(e) => { e.currentTarget.src = "/acorn-t.png"; e.currentTarget.classList.add("fallback"); }} />
          </div>
          <div>
            <h1 className="pp-h1" data-testid="about-name">Stephanie Lowe Burry, LCSW</h1>
            <p className="pp-sub">Licensed Clinical Social Worker · Indiana</p>
            <div className="pp-about-bio" data-testid="about-bio">
              <p>Stephanie is a Licensed Clinical Social Worker with 30 years of experience working with children, teens, adults, and families in Indiana. She specializes in Life Cycle Work — helping people understand and navigate the major transitions we all experience in life.</p>
              <p>She is an author, speaker, retreat & workshop facilitator, and podcast host.</p>
            </div>
          </div>
        </div>
        <section className="mt-12">
          <h2 className="pp-h2">How Stephanie helps families</h2>
          <ul className="pp-services" data-testid="about-services">
            {SERVICES.map((s) => <li key={s}>{s}</li>)}
          </ul>
        </section>
        <section className="pp-card mt-10 max-w-xl" data-testid="about-contact">
          <h2 className="pp-h2 mb-4" data-testid="about-contact-heading">For more information about BurrHaus Counseling and Colorful Acorn Parenting, go to</h2>
          <Contact />
        </section>
      </main>
      <Footer />
    </div>
  );
}
